import { Lock, LogOut, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { useSubscription } from '@/hooks/useSubscription';
import PlanPicker from './PlanPicker';

/**
 * Full-page block shown once a company's free trial has run out.
 * Their data is untouched — they just cannot use the app until they pick a plan.
 */
export const TrialExpiredWall = () => {
  const { signOut } = useAuth();
  const { tenantName, unitCount } = useSubscription();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-accent/20 p-4">
      <div className="container max-w-5xl mx-auto py-10">
        <div className="text-center mb-8">
          <div className="mx-auto mb-4 h-12 w-12 rounded-full bg-orange-500/15 text-orange-500 flex items-center justify-center">
            <Lock className="h-6 w-6" />
          </div>
          <h1 className="text-3xl font-bold mb-2">Your free trial has ended</h1>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Everything you logged for {tenantName || 'your business'} is safe. Choose a plan to get straight
            back to your checklists, reports and audit history.
          </p>
        </div>

        <PlanPicker defaultUnits={Math.max(1, unitCount)} />

        <div className="mt-10 text-center space-y-3">
          <p className="text-sm text-muted-foreground flex items-center justify-center gap-2">
            <Mail className="h-4 w-4" />
            Questions or need more time? Email{' '}
            <a href="mailto:info@crystalhaccp.com" className="font-medium underline">
              info@crystalhaccp.com
            </a>
          </p>
          <Button variant="ghost" size="sm" onClick={signOut}>
            <LogOut className="h-4 w-4 mr-2" />
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TrialExpiredWall;
